import React from "react";
import {ContactEvent, ContactEventRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import {Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import {types} from "../../../../components/form/types";

export const ContactEventEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(ContactEventRestControllerApiFactory);

    const form = useForm({
        fetcher: (id) => ctrl.getContactEvent(id),
        updater: (bean) => ctrl.saveContactEvent(bean),
        remover: (id) => ctrl.deleteOrDismissContactEvent(id),
        factory: () => ({} as ContactEvent),
    } as UseFormProps<ContactEvent>);

    return (
        <FormContent form={form} title={"Formulario de interacción"}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <FormAutocomplete field={"contact"} label={"Contacto"} type={types.contacts}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormSelect field={"type"} label={"Tipo"} type={types.contactEventTypes}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormInput field={"issueDate"} label={"Fecha y hora"} type="datetime"/>
                </Grid>
            </Grid>

            <FormInput field={"description"} label={"Descripción"} rows={5}/>
        </FormContent>
    );
};
